<template lang="pug">
breadcrumb-view.home
	h1 You seem to be lost!
	p
		a.button(href="/") Go Home

	div(v-if="!getIsProductionEnvironment()").dev-nav
		hr
		p You also may have been looking for...
		p
			router-link.button(:to="{ name: 'DeviceManager' }") Total Stations
			router-link.button(:to="{ name: 'FloodDss'}") Flood Status
			router-link.button(:to="{ name: 'ChangeRequests.User.Request' }") Add User
			router-link.button(:to="{ name: 'VUFeed' }") TFM-VU Feed
			//- router-link.button(:to="{ name: 'Sandbox' }") Sandbox
			//- router-link.button(:to="{ name: 'Manage' }") Manage
			//- router-link.button(:to="{ name: 'Account' }") Account (Blank)
			router-link.button.is-error(:to="{ name: 'ResetPassword' }") Password Reset
</template>

<script>
import Component, { mixins } from "vue-class-component";
import BreadcrumbView from "@/views/BreadcrumbView";
import EnvAware from "@/mixins/EnvAware";

@Component({
	components: { BreadcrumbView }
})
class Home extends mixins(EnvAware) {}

export default Home;
</script>

<style lang="stylus" scoped>
.home
	p
		margin 0.5em

		> .button
			margin 0.25em

	.dev-nav
		padding 0 0.5em

		.button
			margin 0
			margin-bottom 0.5em
			width 100%
</style>
